import Header from "../components/feature/Header";
import Footer from "../components/feature/Footer";
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />

      <main className="flex-grow flex flex-col items-center justify-center text-center px-4">
        <h1 className="text-5xl md:text-5xl font-semibold text-gray-900">404</h1>
        <h2 className="text-2xl md:text-3xl font-semibold mt-6">This page has not been generated</h2>
        <p className="mt-4 text-xl md:text-2xl text-gray-500">Tell me what you would like on this page</p>
        <div className="mt-6">
          <Link to="/" className="inline-block px-6 py-3 bg-gray-900 text-white rounded hover:bg-gray-800 transition">Home</Link>
        </div>
      </main>

      <Footer />
    </div>
  );
}